'use client';

import Link from 'next/link';
import { useEffect } from 'react';

export default function NotFound({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="max-w-md text-center">
        <h1 className="text-9xl font-bold text-emerald-600">404</h1>
        <p className="mt-4 text-2xl font-semibold text-gray-900">
          Page Not Found
        </p>
        <p className="mt-2 text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link 
          href="/" 
          className="mt-6 inline-flex items-center px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
}
